import { GlobalState } from "context/GlobalContext";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import FileSaver from "file-saver";
import {itemMasterfilterColArry} from "./data"
import { constraintsOptions, inputTypes, selectOptKeyName } from "data/globalData";
import { getColDefaultValue, isColumnDefault } from "components/EboStoreV4/data";
import RenderInputField from "components/EboStoreV4/CommonComponents/RenderInputFiled/RenderInputFiled";
import { AuthState } from "context/AuthContext";
import QueryFilterPanel from "components/CustomQueriesDashboard/ReusableComponents/QueryFilterPanel/QueryFilterPanel";

const ItemMaster = () => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const [loading, setLoading] = useState(false);
	const { user } = AuthState();
	const [filterColumns, setFilterColumns] = useState(itemMasterfilterColArry);
	const [brand, setBrand] = useState([])
	const [division, setDivision] = useState([])
	const [season, setSeason] = useState([])
	const [department, setDepartement] = useState([])

	const defaultData = itemMasterfilterColArry?.reduce((acc, row) => {
		acc[row.key] = getColDefaultValue(row);
		return acc;
	}, {});

	const [filterData, setFilterData] = useState({ ...defaultData });

	const fetchDropdownValues = async () => {
		// api call to fetch dropdown values.
		setLoadingOpen(true);
		try {
			await pythonVmInstance.get("custom_queries/item_master/get_filters").then((res) => {
				console.log("first res", res.data);
				const message = res?.data?.message
				const result = res?.data?.result[0]
				const status = res?.data?.status

				setBrand(result.brand)
				setDivision(result.division)
				setSeason(result.season)
				setDepartement(result.department)

				setLoadingOpen(false);
				setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: message,
				severity: status,
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			});
		} catch (error) {
			setLoadingOpen(false);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "unable to fetch values for dropdown",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};

	useEffect(() => {
		fetchDropdownValues();
	}, []);

	const handleDownloadItemMaster = async (e) => {
		e.preventDefault();
		setLoading(true);
		let pendingFields = [];
		itemMasterfilterColArry?.forEach((attr) => {
			if (isColumnDefault(attr, filterData?.[attr?.key]) && attr?.constraints?.[constraintsOptions.NOTNULL.key] === true)
				pendingFields.push(attr);
		});

		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);

			return;
		}

		let show_cogs = false
		if (user?.role?.ADMIN || user?.role?.COGS) show_cogs = true

		try {
			await pythonVmInstance({
				url: `/custom_queries/item_master/download`,
				headers: {
					"Content-Type": "application/json",
				},
				method: "post",
				responseType: "blob",
				data: {
					...filterData,show_cogs
				},
			}).then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `ITEM_MASTER_${new Date().toISOString().split("T")[0]}.csv`);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Downloaded the file",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoading(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			console.log("asdfghjkl", error);
			setSnackBar({
				...snackBar,
				message: `failed to run query ${error}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);
		}
	};
console.log('filterData',filterData)
	return (
		<QueryFilterPanel onSubmit={handleDownloadItemMaster} loading={loading} submitLabel="Download">
			{filterColumns?.map((col) => {
				let fieldCol = col;
				if (col?.key === 'season'){
					fieldCol = { ...col, select_options: { ...col.select_options, list: season, getOptionLabel: (value) =>({name: value, key: value}) } };
				}
				if (col?.key === 'brand'){
					fieldCol = { ...col, select_options: { ...col.select_options, list: brand, getOptionLabel: (value) =>({name: value, key: value}) } };
				}
				if (col?.key === 'division'){
					fieldCol = { ...col, select_options: { ...col.select_options, list: division, getOptionLabel: (value) =>({name: value, key: value}) } };
				}
				if (col?.key === 'department'){
					fieldCol = { ...col, select_options: { ...col.select_options, list: department, getOptionLabel: (value) =>({name: value, key: value}) } };
				}
				return (
					<RenderInputField
						key={col.key}
						column={fieldCol}
						data={filterData}
						setData={setFilterData}
						selectOptObjName={"select_options"}
						width={"100%"}
						longWidth={"300px"}
						disabled={false}
					/>
				);
			})}
		</QueryFilterPanel>
	);
};

export default ItemMaster;
